class CollapsibleContent extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('[data-collapsible-trigger]').forEach((trigger) => {
      trigger.addEventListener('click', this.onToggle.bind(this));
    });
  }

  onToggle(event) {
    const trigger = event.currentTarget;
    const item = trigger.closest('[data-collapsible-item]');
    const panel = item?.querySelector('[data-collapsible-panel]');
    const isOpen = item?.classList.toggle('is-open');

    trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

    if (panel && isOpen) {
      panel.style.setProperty('--collapsible-panel-height', `${panel.scrollHeight}px`);
    }
  }
}

if (!customElements.get('collapsible-content')) {
  customElements.define('collapsible-content', CollapsibleContent);
}
